/**
 * Centralized notification configuration
 * Modify this file to change notification behavior globally
 */
export const NOTIFICATION_CONFIG = {
  // Global defaults (inherited by all types)
  global: {
    position: 'top-right',
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    newestOnTop: true,
  },

  // Success notification config
  success: {
    autoClose: 3000,
    className: 'toast-success',
  },

  // Error notification config
  error: {
    autoClose: 5000, // Longer duration for errors
    className: 'toast-error',
  },

  // Warning notification config
  warning: {
    autoClose: 4000,
    className: 'toast-warning',
  },

  // Info notification config
  info: {
    autoClose: 3000,
    className: 'toast-info',
  },

  // Loading notification config
  loading: {
    autoClose: false,
    closeButton: false,
    className: 'toast-loading',
  },
};

/**
 * ToastContainer configuration for App.js
 * Use this to configure the ToastContainer component
 */
export const TOAST_CONTAINER_CONFIG = {
  position: 'top-right',
  autoClose: 3000,
  hideProgressBar: false,
  newestOnTop: true,
  closeOnClick: true,
  rtl: false,
  pauseOnFocusLoss: true,
  draggable: true,
  pauseOnHover: true,
};
